import React from 'react'
import './home.css';
import Button from "../../components/button/Button"

const Home = () => {
  return (
    <section className="home-background">
      <div className="home-container">
        <div className="home-title">
              NK REPUESTOS MARCOS PAZ
        </div>
        <div className="home-text">
              Si tiene su tv bloqueada en el standby, o con algún problema de Software, reinstalar el Firmware puede ser la solución...
        </div>
          <div className="home-buttons">
            <Button route={`/explanation`} text="¿Qué es un Firmware?" />
            <Button route={`/brands`} text="Lista de Firmwares" />
            <Button route={`/about`} text="Quienes Somos" />
          </div>
      </div>
    </section>
  )
}

export default Home;